import { MapActionType } from '../../services/map/map.action-types';
import {AuthActionType } from '../../services/main/main.action-types';
import { MapAction } from '../../services/map/map.action-rule';
import LayerInfo from './models/LayerInfo';

type FeatureTableState = {
  display: boolean,
  selectedLayer?: __esri.FeatureLayer
}

export type Model = {
  layerInfos?: LayerInfo[],
  view?: __esri.MapView | __esri.SceneView,
  featureTable: FeatureTableState
};

export const defaultState: Model = {
  featureTable: {
    display: true
  }
};

function reducer(state: Model = defaultState, action: MapAction): Model {
  switch (action.type) {
    case MapActionType.LAYERINFO_REQUEST:
    case MapActionType.LAYERINFO_FAIL:
      return state;
    case MapActionType.LAYERINFO_SUCESS:
      return { ...state, layerInfos: action.layerInfos };
    case MapActionType.VIEW_INIT:
      return { ...state, view: action.view };
    case AuthActionType.LOGOUT as any:
      return defaultState;
      case MapActionType.DISPLAY_FEATURETABLE:
      return { ...state, featureTable: { ...state.featureTable, display: action.mode, selectedLayer: action.layer } };
    default:
      return state;
  }
}

export default reducer;